<template>
	<div id="sidebar" class="col-xs-12 col-lg-4 mt-3 mt-lg-0">
		<hr class="d-block d-lg-none mb-5" />
		<umia-sidebar v-if="brand == 'umia'" />
		<umia-sidebar v-if="brand == 'mmic'" />
		<umia-sidebar v-if="brand == 'amic'" />
		<insurecareteams-sidebar v-if="brand == 'insurecareteams'" />
	</div>
</template>

<script>
import UmiaSidebar from './Umia-Sidebar.vue';
import InsurecareteamsSidebar from './Insurecareteams-Sidebar.vue';

export default {
	name: 'Sidebar',
	components: {
		UmiaSidebar,
		InsurecareteamsSidebar,
	},
};
</script>
